import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import type { TabsGroupItemProps } from '@/js/libs/ui/src/V2';
import { Table, TabsGroup } from '@/js/libs/ui/src/V2';

import { useTaskTablesContext } from '../context';
import { TaskTableStatus } from '../types';

export const TableTabs: React.FC = React.memo(function TableTabs() {
  const [t] = useTranslation(['backend', 'common', 'serviceDashboard']);
  const { status, updateStatus } = useTaskTablesContext();

  const items = React.useMemo<TabsGroupItemProps[]>(
    () => [
      {
        id: TaskTableStatus.ALL,
        title: t('serviceDashboard:ALL_TASKS'),
        dataTestId: `status-${TaskTableStatus.ALL}-tab`,
      },
      {
        id: TaskTableStatus.UNASSIGNED,
        title: t('serviceDashboard:UNASSIGNED'),
        dataTestId: `status-${TaskTableStatus.UNASSIGNED}-tab`,
      },
      {
        id: TaskTableStatus.IN_PROGRESS,
        title: t('serviceDashboard:IN_PROGRESS'),
        dataTestId: `status-${TaskTableStatus.IN_PROGRESS}-tab`,
      },
      {
        id: TaskTableStatus.SNOOZED,
        title: t('serviceDashboard:SNOOZED'),
        dataTestId: `status-${TaskTableStatus.SNOOZED}-tab`,
      },
      {
        id: TaskTableStatus.DONE,
        title: t('common:DONE'),
        dataTestId: `status-${TaskTableStatus.DONE}-tab`,
      },
      {
        id: TaskTableStatus.ARCHIVED,
        title: t('serviceDashboard:ARCHIVED'),
        dataTestId: `status-${TaskTableStatus.ARCHIVED}-tab`,
      },
    ],
    [t],
  );

  const onChange = useCallbackRef((value: string | number) => {
    updateStatus(value);
  });

  return <Table.CardHeader tabs={<TabsGroup items={items} activeId={status} onChange={onChange} />} />;
});
